/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

import { INodeProps } from './node';

export interface IModuleProps extends INodeProps {
    moduleProps: Msdyn365.IModule;
}

export const Module: React.FC<IModuleProps> = React.forwardRef(
    ({ className = '', id = '', tag: Tag = 'div', moduleProps, ...restAttribute }, ref) => {
        return <Tag className={className} id={id} {...moduleProps.renderModuleAttributes(moduleProps)} {...restAttribute} ref={ref} />;
    }
);

export default Module;
